<script>
  import './styles/view/HowToUse.css';
  import Navigation from './components/layout/Navigation.svelte';
  
  export let user; // 사용자 정보
  export const setPage = null; // 페이지 변경 함수
  export const isAdmin = null; // 관리자 여부
  
  let activeTab = 'guide01'; // 기본 활성 탭: 회원가입
  
  function setActiveTab(tab) {
    activeTab = tab;
  }
</script>

<div class="howto-container">
  <Navigation 
    {user}
    currentPage="how-to-use"
  />

  <div class="content-container">
    <div class="tabs">
      <button 
        class="tab-btn" 
        class:active={activeTab === 'guide01'} 
        on:click={() => setActiveTab('guide01')}>
        회원 가입
      </button>
      <button 
        class="tab-btn" 
        class:active={activeTab === 'guide02'} 
        on:click={() => setActiveTab('guide02')}>
        <span>지원 방법</span>
      </button>
      <button 
        class="tab-btn" 
        class:active={activeTab === 'guide03'} 
        on:click={() => setActiveTab('guide03')}>
        진행 절차
      </button>
    </div>
    
    <div class="tab-content">
      {#if activeTab === 'guide01'}
        <div class="guide">
          <h3>간편한 회원가입으로 <span style="color: #3273dc;">WIDE-WORK</span> 서비스를 이용할 수 있습니다.</h3>
          <p>기본 정보를 입력하여 간편하게 가입 후 프로젝트에 지원해 보세요.</p>

          <div class="guide-info">
            <h4>가입 절차 안내</h4>
            <p><strong>필수 정보를 입력하면 바로 가능합니다.</strong></p>
            <p class="highlight-small">* 이메일 인증 필수</p>
            <p class="highlight-small">* 만 14세 이상만 가입 가능합니다.</p>
          </div>

          <div class="guide-image">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="80" height="80" fill="#3273dc">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
            </svg>
          </div>

          <div class="guide-info">
            <h4>계정 정보</h4>
            <p>가입 시 이메일 주소로 ID가 생성되며 로그인 후 이용 가능합니다.</p>
            <p class="highlight-small">* 마이페이지 > 정보수정 > 첨부 문서</p>
          </div>
        </div>
      {:else if activeTab === 'guide02'}
        <div class="guide">
          <h3 style="text-align: left;"><span style="color: #3273dc;">WIDE-WORK</span>에서 원하는 프로젝트에 참여 신청을 할 수 있습니다.</h3>
          <p>프로젝트 지원 단가, 면접 및 출근 가능일, 해당 스킬 경험 <br>관련 내용을 작성해 주세요. 

          <div class="guide-info">
            <h4>지원 정보 입력</h4>
            <p>해당 스킬의 숙련도 및 경험 프로젝트 등을 상세히 기재해 주시면  <br>보다 효율적인 진행이 가능합니다.</p>
            <p class="highlight">* 이력서 파일 첨부 필수</p>
          </div>

          <div class="guide-image">
            <img src="/registration.png" alt="프로젝트 지원 등록" width="500" height="350" style="max-width: 100%; height: auto;">
          </div>

          <div class="guide-info">
            <h4>프로젝트 신청 방법</h4>
            <p>프로젝트 내용을 확인하고 단가를 입력하면 바로 참여 신청이 완료됩니다.</p>
          </div>

          <div class="guide-info">
            <h4>담당자 연결 및 진행</h4>
            <p>지원 후 담당자가 검토하며 진행 상황은 마이페이지에서 확인 가능합니다.</p>
          </div>

          <div class="guide-info">
            <h4>추천 절차</h4>
            <p>담당자가 지원 정보를 검토한 후 고객사 요건에 맞춰 추천드립니다.</p>
          </div>

          <div class="guide-info">
            <h4>인터뷰 진행</h4>
            <p>서류 합격 시 고객사와 인터뷰 일정을 협의하여 진행합니다.</p>
          </div>
        </div>
      {:else if activeTab === 'guide03'}
        <div class="guide">
          <h3><span style="color: #3273dc;">WIDE-WORK</span> 인터뷰 합격 후 계약까지 3단계로 진행됩니다.</h3>
          <p>각 단계별로 필요한 서류와 절차를 안내해 드립니다.</p>

          <div class="step-container">
            <div class="step-item">
              <div class="step-number">1</div>
              <div class="step-content">
                <h4>최종 합격 통보</h4>
                <p>담당자가 최종 합격을 안내하며 출근일과 계약서류를 요청드립니다.</p>
              </div>
            </div>

            <div class="step-item">
              <div class="step-number">2</div>
              <div class="step-content">
                <h4>계약서 검토 및 체결</h4>
                <p>계약서 내용을 확인한 후 전자 계약 방식으로 체결을 진행합니다.</p>
              </div>
            </div>

            <div class="step-item">
              <div class="step-number">3</div>
              <div class="step-content">
                <h4>업무 시작 및 관리</h4>
                <p>업무 시작일부터 계약 만료까지 이슈 관리 및 연장 등을 지원합니다.</p>
              </div>
            </div>
          </div>

          <div class="guide-info">
            <h4>지원 관련 문의</h4>
            <p>진행 중 궁금한 사항은 담당자에게 연락하거나 마이페이지를 확인해주세요.</p>
          </div>
        </div>
      {/if}
    </div>
  </div>
  
  <footer>
    <div class="company-info">
      <h3>주식회사 비전와이드</h3>
      <p>대표자명 : 최병영 | 사업자등록번호 : 134-87-40607 | 통신판매업신고 : 제2023-서울구로-2412호</p>
      <p>서울특별시 구로구 디지털로34길 55, B201-H4호 (구로동, 코오롱싸이언스밸리2차)</p>
      <p>TEL : 02-565-5747 | FAX : 02-6499-5747 | E-mail : admin@visionwide.kr</p>
      <p>©VISIONWIDE. ALL RIGHTS RESERVED.</p>
    </div>
  </footer>
</div>
